import { useState } from "react";

const PartnerDelegateReadOnlyRow = ({ index, t, delegateItem, handleDeleteClick, handleSubmit, 
							handleAppSurvey, handleLocation, handleProduct, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const today = new Date().toISOString().split("T")[0];
	const [dates, setDates] = useState({ startDate: delegateItem.startDate, endDate: delegateItem.endDate });
	function submitComplete() {
		setIsSubmit(false);
	}
	

	function submitDelete(event, delegateItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, delegateItem, submitComplete);
	}
	
	function handleEditClick(event, delegateItem) {
		setIsSubmit(false);
		setDates({ ...dates, startDate: delegateItem.startDate, endDate: delegateItem.endDate });
		setIsEditMode(true);
	}
	const valueHandler = (e) => {
		const { name, value } = e.target;
		if (typeof value === 'undefined') {
			value = "";
		}
		setDates({ ...dates, [name]: value });
	}
	function submitUpdate(event, delegateItem) {
		setError("");
		setIsSubmit(true);
		let errors = "";
		if (!dates.startDate) {
			errors = t("error.startdateReqd");
			setIsSubmit(false);
		} else if (!delegateItem || delegateItem.delegateKey == 0){
			errors += t("error.delegateKeyReqd");
			setIsSubmit(false);
		} else {
			let initialValues = {
				delegateKey: delegateItem.delegateKey,
				partnerKey: delegateItem.companyId,
				parentDelegateKey: delegateItem.parentDelegateKey,
				startDate: dates.startDate,
				endDate: dates.endDate,
			};
			handleSubmit(2, initialValues, submitComplete);
		}
		setError(errors);
		
	}
	function submitComplete() {
		setIsSubmit(false);
		setIsEditMode(false);
	}
	function submitCancel(event, delegateItem) {
		setError("");
		setIsEditMode(false);
		setIsSubmit(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td-sm col text-wrap odd" : "list-td-sm col text-wrap even"}>{(delegateItem.parentCompanyName)? delegateItem.parentCompanyName:""}</td>
			<td className={oddIdx ? "list-td-sm col text-wrap odd" : "list-td-sm col text-wrap even"}>{delegateItem.companyName+ ', ' + (delegateItem.city ? delegateItem.city + ', ' : '') + delegateItem.stateCode + ', ' + delegateItem.countryCode}</td>
			{isEditMode ?  
			<>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<input
					type="date"
					name="startDate"
					id="startDate"
					value={dates.startDate || today}
					onChange={valueHandler}
					className="form-control rounded-pill shadow-sm px-4 "
					max={today}
				/></td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<input
					type="date"
					name="endDate"
					id="endDate"
					value={dates.endDate}
					onChange={valueHandler}
					className="form-control rounded-pill shadow-sm px-4 "
				/></td>
			</>
			:
			<>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.startDate}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.endDate}</td>
			</>
			}
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.status}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>
				<button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleAppSurvey(event, delegateItem)}>{t("page.appSurvey")}</button>
				<button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleLocation(event, delegateItem)}>{t("page.loc")}</button>
				<button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleProduct(event, delegateItem)}>{t("page.prod")}</button>
			</td>
			<td className={oddIdx ? "list-td-sm col col-md-auto odd" : "list-td-sm col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
				<>
				<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
					onClick={(event) => submitUpdate(event, delegateItem)}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
					onClick={(event) => (submitCancel(event, delegateItem))}>{t("page.cancel")}</button>
				</>
				):(
				<>
				<button className="btn btn-primary btn-block me-3 mb-0" onClick={(event) => handleEditClick(event, delegateItem)}>{t("page.edit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, delegateItem)}>
					{delegateItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
				</>
				)}
			</td>
		</tr>
	)
}
export default PartnerDelegateReadOnlyRow;